<template>
	<div 
		class="knd-tooltip" 
		ref="tooltip"
		:class="{'show': show, 'viewport-small': smallViewport}"
		:style="{left: x +'px', top: y + 'px'}">
		<div class='knd-tooltip-wrapper' ref="tooltip--wrapper">
			<slot />
		</div>
	</div>
</template>

<script>
	import * as d3 from 'd3';

	import './index.scss';

	const vueObject = {
		props: ['event', 'show'],
		data: function() {
			return {
				x: 0,
				y: 0,
				paddingLeft: 10,
				paddingTop: 15,
				smallViewport: false
			}
		},

		mounted: function() {
			const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

			this.smallViewport = vw < 550 ? true : false;
		},

		watch: { 
			event: function(newVal, oldVal) { // watch it
				if(!this.show) return;

				const[x, y] = d3.pointer(event);
				let el = this.$refs.tooltip;

				let tooltipBounds = this.$refs.tooltip.getBoundingClientRect();

				let tooltipX = x + this.paddingLeft - (tooltipBounds.width /2);
				let tooltipY = y + this.paddingTop;

				tooltipX = this.checkBoundingX(tooltipX, el);
				tooltipY = this.checkBoundingY(tooltipY, el);

				this.x = tooltipX;
				this.y = tooltipY;
			}
		},

		methods: {
			checkBoundingY(y, el) {
				let vwH = document.documentElement.clientHeight;

				if( y < 0) {
					y = 0;
				} else if (y + el.offsetHeight > vwH) {
					y = vwH - (el.offsetHeight + 10);
				}

				return y;
			},

			checkBoundingX(x, el) {
				let vwW = document.body.clientWidth;
				let nodeW = el.offsetWidth;

				if( x < 0 ) {
					x = 0;
				} else if ((x + this.paddingLeft + nodeW) > vwW) {
					x = vwW - nodeW - 2;
				}

				return x;		
			}		
		}

	}

	export default vueObject;
</script>